import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

//@Injectable()
@Injectable({ providedIn: 'root' })
export class LoadingBarService {

  isVisibleSource: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {}

  show() {
    // AI: Defer emission to the next tick to prevent ExpressionChangedAfterItHasBeenCheckedError
    // when a component that triggers an HTTP request (and thus this service) is created.
    setTimeout(() => this.isVisibleSource.next(true));
  }

  hide() {
    // AI: Defer emission to the next tick for consistency and to prevent similar errors.
    setTimeout(() => this.isVisibleSource.next(false));
  }
}
